'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$167(ps$90) {
  this.a6X = null;
  this.a6X = ps$90;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$167 as $c_Lmealorama_jsonCodecs$package$$anon$167 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$167.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$167;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$167() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$167 as $h_Lmealorama_jsonCodecs$package$$anon$167 };
$h_Lmealorama_jsonCodecs$package$$anon$167.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6X.a.length;
});
$p.g = (function(i) {
  return this.a6X.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$167 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$167, "mealorama.jsonCodecs$package$$anon$167", ({
  Jk: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$167 as $d_Lmealorama_jsonCodecs$package$$anon$167 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$167.js.map
